import { useEffect, useState } from "react";
import { SetsContent } from "./SetsContent";
import { PracticeRepository } from "@/infrastructure/repositories/PracticeRepository";
import { FolderRepository } from "@/infrastructure/repositories/FolderRepository";

export function SetsContentWrapper({
  onSectionChange,
}: {
  onSectionChange: (section: string) => void;
}) {
  const [practice, setPractice] = useState<any | null>(null);
  const [laps, setLaps] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem("selected_practice");
    if (!stored) {
      onSectionChange("practice");
      return;
    }

    const parsed = JSON.parse(stored);
    console.log("[SetsSaveDebug] wrapper:selected_practice", {
      id: parsed?.id,
      practice_id: parsed?.practice_id,
      practiceId: parsed?.practiceId,
      folder_id: parsed?.folder_id,
      folderId: parsed?.folderId,
      folder_practice_model_id: parsed?.folder_practice_model_id,
      folder_practice_id: parsed?.folder_practice_id,
    });
    setPractice(parsed);

    const fetchLaps = async () => {
      try {
        const practiceRepo = new PracticeRepository();
        const folderRepo = new FolderRepository();
        const userId =
          localStorage.getItem("selected_swimmer_id") ||
          localStorage.getItem("current_user_swimmer_id");

        const [practiceResp, folderResp] = await Promise.all([
          practiceRepo.findByUserId(userId || ""),
          folderRepo.getAllFoldersPaginated(
            Number(userId || 0),
            1,
            200
          ),
        ]);

        const targetIds = [
          parsed.practice_id,
          parsed.practiceId,
          parsed.id,
          parsed.folder_practice_model_id,
          parsed.folder_practice_id,
        ]
          .filter(Boolean)
          .map(String);

        const practiceLaps =
          practiceResp.laps?.filter((lap: any) => {
            const lapPracticeId =
              lap.practice_id ?? lap.folder_practice_model_id;
            return lapPracticeId
              ? targetIds.includes(String(lapPracticeId))
              : false;
          }) || [];

        const folderLaps =
          folderResp?.laps?.filter((lap: any) => {
            const lapPracticeId =
              lap.folder_practice_model_id ?? lap.practice_id;
            return lapPracticeId
              ? targetIds.includes(String(lapPracticeId))
              : false;
          }) || [];

        setLaps([...practiceLaps, ...folderLaps]);
      } catch (err) {
        console.error("Failed to fetch laps:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchLaps();
  }, [onSectionChange]);

  if (isLoading) {
    return (
      <div className="text-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
        {/* <p className="text-muted-foreground">Loading...</p> */}
      </div>
    );
  }

  if (!practice) {
    return (
      <div className="text-center py-20">
        <p>No practice selected.</p>
        <button
          onClick={() => onSectionChange("practice")}
          className="flex items-center space-x-1"
        >
          Back
        </button>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-4">
        <button
          onClick={() => onSectionChange("practice")}
          className="flex items-center space-x-1"
        >
          Back
        </button>
      </div>

      <SetsContent
        laps={laps}
        practiceId={
          practice?.folder_practice_model_id ??
          practice?.practice_id ??
          practice?.practiceId ??
          practice?.id
        }
        folderId={practice?.folder_id ?? practice?.folderId}
        name={practice?.name}
        description={practice?.description}
        practiceDate={practice?.practice_date ?? practice?.PracticeDate ?? practice?.date}
        practiceTime={practice?.practice_time ?? practice?.practiceTime}
        courseTypeLookupId={practice?.courseTypeLookupId ?? practice?.CourseTypeLookupId}
        onClose={() => onSectionChange("practice")}
        onSectionChange={onSectionChange}
      />
    </div>
  );
}
